<template>
  <div class="grid grid-cols-12 border rounded text-sm gap-x-4 p-4 items-center">
    <ValidationProvider
      rules="required"
      :name="`paymentLines[${num}].description`"
      tag="div"
      class="col-span-9"
    >
      <template #default="{ errors }">
        <BaseFormInput v-model="computedDescription" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required|min_value:0.01"
      :name="`paymentLines[${num}].amount`"
      tag="div"
      class="col-span-2"
    >
      <template #default="{ errors }">
        <BaseFormInput
          v-model="computedAmount"
          type="number"
          min="0"
          step="0.01"
          :disabled="disabled"
          class="text-right"
        />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <div class="text-right">
      <a role="button" @click="$emit('invoice-line-item:remove')"> Delete </a>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    num: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      default: 0,
    },
    disabled: Boolean,
  },

  computed: {
    computedDescription: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit('update:description', value);
      },
    },
    computedAmount: {
      get() {
        return this.amount;
      },
      set(value) {
        if (Number.isNaN(value)) return;
        this.$emit('update:amount', value);
      },
    },
  },
};
</script>
